import { Category } from './category';
import { Company } from './company';

export interface User {
  id: string;
  firstName?: string;
  lastName?: string;
  gender?: string;
  birthYear?: string;
  acceptedPrivacyPolicy?: boolean;
  acceptedAgb?: boolean;
  zipCode?: string;
  email?: string;
  companyName?: string;
  isAdvisoryboard?: boolean;
  isRegionalAdvisoryboard?: boolean;
  profilePicture?: ProfilePicture;
  profilePictureId?: string;
  profilePictureUrl?: string;
  address?: {
    id: string;
    street: string;
    city: string;
    country: string;
    plz: string;
    state: string;
    streetAndNumber: string;
  };
  birthdate?: string;
  managerId?: string;
  roles?: string[];
  categoryIds?: string[];
  categories?: Category[];
  advisoryCategories?: string[];
  advisoryExcludedBezirkIds?: string[];
  company?: Company;
}

export class ManagedUser {
  id: string | null = null;
  firstName: string;
  lastName: string;
  gender: string | null = null;
  private _birthYear: number | string | null = null;
  zipCode: string | null = null;
  profilePicture: ProfilePicture | null = null;
  categories: Category[] = [];

  constructor(
    id: string | null = null,
    firstName: string,
    lastName: string,
    gender: string | null = null,
    birthYear: number | string | null = null,
    zipCode: string | null = null,
    profilePicture: ProfilePicture | null = null,
    categories: Category[] = [],
  ) {
    this.id = id;
    this.firstName = firstName;
    this.lastName = lastName;
    this.gender = gender;
    this._birthYear = birthYear;
    this.zipCode = zipCode;
    this.profilePicture = profilePicture;
    this.categories = categories;
  }

  get birthYear(): number | null {
    return this._birthYear ? parseInt(this._birthYear as string) : null;
  }
}

export interface ProfilePicture {
  id: string;
  url: string;
}
